import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

import { connect } from "react-redux";

import { SnackbarProvider, enqueueSnackbar } from "notistack";

import {
  getCustomLicenses,
  getOrgAccounts,
  clearAllCustomLicenseMessages,
} from "../store/actions";

import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  Chip,
} from "@mui/material";

import { Alert } from "reactstrap";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import spinner from "../assets/images/loadingGif.gif";

import CustomLicenseAddEditModal from "./CustomLicenseAddEditModal";
import CustomLicensesTable from "./CustomLicensesTable";
import { getEmptyCustomLicense } from "./emptyCustomLicense";


const CustomLicenseManager = (props) => {
  console.log("CustomLicenseManager props: ", props);
  const { orgCode } = useParams();
  const [addEditModalOpen, setAddEditModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);

  const appBarStyles = {
    backgroundColor: 'whitesmoke',
    // Add more custom styles as needed
  };

  const clearAllMessages = useCallback(() => {
    props.clearAllMessages();
  }, []);

  const getCustomLicenses = useCallback(() => {
    props.getCustomLicenses(orgCode);
  }, [orgCode]);

  const getOrgAccounts = useCallback(() => {
    props.getOrgAccounts(orgCode);
  }, [orgCode]);

  useEffect(() => {
    getCustomLicenses(orgCode);
    getOrgAccounts(orgCode);
  }, [orgCode, getCustomLicenses, getOrgAccounts]);

  //For displaying message for getting custom license information
  let getCustomLicensesMsg = props.getCustomLicensesMessage;
  let getCustomLicensesErr = props.getCustomLicensesError;
  useEffect(() => {
    console.log("getCustomLicensesMsg = " + getCustomLicensesMsg);
    if (getCustomLicensesMsg || getCustomLicensesErr) {
      console.log("Inside if, getCustomLicensesMsg = " + getCustomLicensesMsg);
        clearAllMessages();
        if(getCustomLicensesMsg) {
          enqueueSnackbar(getCustomLicensesMsg, {variant: "success"});
        }
        if(getCustomLicensesErr) {
          enqueueSnackbar(getCustomLicensesErr, {variant: "error"});
        }
    }
  }, [getCustomLicensesMsg, getCustomLicensesErr, clearAllMessages]);


  //For displaying message for adding custom license information
  let addCustomLicenseMsg = props.addCustomLicenseMessage;
  let addCustomLicenseErr = props.addCustomLicenseError;
  useEffect(() => {
    console.log("addCustomLicenseMsg = " + addCustomLicenseMsg);
    if (addCustomLicenseMsg || addCustomLicenseErr) {
      console.log(
        "Inside if, addCustomLicenseMsg = " + addCustomLicenseMsg
      );
      clearAllMessages();
      if(addCustomLicenseMsg) {
        enqueueSnackbar(addCustomLicenseMsg, {variant: "success"});
        getCustomLicenses(orgCode);
        setAddEditModalOpen(false);
      }
      if(addCustomLicenseErr) {
        enqueueSnackbar(JSON.stringify(addCustomLicenseErr), {variant: "error"});
      }
    }
  }, [addCustomLicenseMsg, addCustomLicenseErr, orgCode, clearAllMessages, getCustomLicenses]);

  const openAddEditCustomLicenseModal = (mode) => {
    console.log("openAddEditCustomLicenseModal called with mode " , mode);
    setModalMode(mode);
    setAddEditModalOpen(true);
  }

  return (
    <div>
      <SnackbarProvider />
      <AppBar position="static" style={appBarStyles}>
        <Toolbar>
          <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
            <Link component={RouterLink} to="/organization" color="inherit">
              <HomeOutlinedIcon />
            </Link>
            <Typography color="textPrimary">
              <Link component={RouterLink} to="/organization" color="inherit">
                Organization{" "}
              </Link>
              / <span id="viewId">View Custom License</span>
            </Typography>
            {props?.organization?.orgname && (<Chip label={props?.organization?.orgname} color="primary" />)}
          </Breadcrumbs>
          <div>
            <Button
              onClick={ () => openAddEditCustomLicenseModal("add") }
            >
              Add Custom License
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      {props.isGettingCustomLicenses && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}
      {props.isUpdatingCustomLicense && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}
      {props.isAddingCustomLicense && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}
      <div>
        {props.getCustomLicensesMessage && (
          <Alert className="mt-3 mb-0" color="success">
            {props.getCustomLicensesMessage}
          </Alert>
        )}
        {props.getCustomLicensesError && (
          <Alert className="mt-3 mb-0" color="danger">
            Error while getting custom license.
            {JSON.stringify(props.getCustomLicensesError?.message)}
          </Alert>
        )}
      </div>

     {/* View Custom Licenses */}
      <div id="viewCustomLicensesId">
        {props.customLicenses && (
          <CustomLicensesTable 
            customLicenses={props.customLicenses} 
            openModalInMode={openAddEditCustomLicenseModal}
            orgCode={orgCode}
          />
        )}
      </div>

      {/* Open Add/Edit Custom License Modal */}
      { addEditModalOpen && modalMode=== "add" && (
        <CustomLicenseAddEditModal 
          mode={modalMode}
          isOpen={addEditModalOpen}
          setOpen={setAddEditModalOpen}
          license={getEmptyCustomLicense(orgCode)}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    organization,
  } = state.orgAccount;

  const {
    isGettingCustomLicenses,
    getCustomLicensesError,
    getCustomLicensesMessage,
    
    isAddingCustomLicense,
    addCustomLicenseError,
    addCustomLicenseMessage,
    
    customLicenses,
  } = state.customLicense;
  return {
    organization,

    isGettingCustomLicenses,
    getCustomLicensesError,
    getCustomLicensesMessage,

    isAddingCustomLicense,
    addCustomLicenseError,
    addCustomLicenseMessage,

    customLicenses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
    getCustomLicenses: (orgCode) => {
      dispatch(getCustomLicenses(orgCode));
    },
    clearAllMessages: () => {
      dispatch(clearAllCustomLicenseMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomLicenseManager);
